import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Paramater, Footer, BottomBar, Loader} from '../layouts/general';
import { BannerProfessional, TabGridV1 } from '../layouts/course';
import { BannerTitle } from '../layouts/general/course';
import { Header, TopBar } from '../layouts/home04';
class CourseV1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    names: 'Courses'
                }
            ],
            titleBanner: [
                {
                    id: '1',
                    classnames: 'flat-title-page parallax parallax8 style4',
                    classoverlay: 'overlay style2',
                    classbread: 'breadcrumbs',
                    titles:'Course',
                    description: 'All our courses are self-paced and have been designed by subject matter experts, to give you an interactive and enriched learning experience.',
                    name01: 'Home', 
                    name02: 'Courses',
                    link01: '/courses-grid-v1',
                    srcimg: 'images/title-page/bg-white.png',

                }
            ]
        }
    }
    render() {
        return (
            <div className="bg-body2">
                <div className="boxed">
                <Loader />
                    <TopBar />
                    {
                        this.state.headers.map(data => (
                            <Header data={data} key={data.id}/>
                        ))
                    }
                    {
                        this.state.titleBanner.map(data => (
                            <BannerTitle data={data} key={data.id}/>
                        ))
                    }
                    <div className="content-wrap courses-grid-v1-page">
                        <div className="container-fluid">
                            <TabGridV1 />
                            <div className="flat-paginations style2">
                                <ul className="list flat-text-center pagination-wrap">
                                    <li className="disabled"><Link to="#" className="btn-navs">PRE</Link></li>
                                    <li className="active"><Link to="#">1</Link></li>
                                    <li><Link to="#">2</Link></li>
                                    <li><Link to="#">3</Link></li>
                                    <li><Link to="#">4</Link></li>
                                    <li><Link to="#">5</Link></li>
                                    <li><Link to="#" className="btn-navs">NEXT</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <section className="flat-feature">
                        <div className="overlay v2" />
                        <div className="container">
                            <Paramater />
                        </div>
                    </section>
                    <section className="flat-free-month parallax parallax9 style2">
                        <div className="container">
                            <BannerProfessional />
                        </div>
                    </section>
                    <Footer />
                    <BottomBar />
                </div>
            </div>
        );
    }
}

export default CourseV1;